import { required, TextInput } from "react-admin";
import React from "react";
import { useField } from "react-final-form";
import { capitalizeFirstLetter } from "../utils/tools";

interface INameInput {
  label: string;
  source: string;
}

const NameInput = ({ label, source }: INameInput) => {
  const {
    input: { onChange },
  } = useField(source);

  return (
    <TextInput
      label={label}
      source={source}
      onChange={(e: any) => {
        const string: string = e.target.value;
        onChange(capitalizeFirstLetter(string));
      }}
      validate={required()}
    />
  );
};

export default NameInput;
